module.exports = __webpack_public_path__ + "img/18e0c3ae-1606-45bc-a3df-88b195cd6773.ae214428.svg";